export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_URLS = {
  // AUTH URLS
  LOGIN: '/login',
  LOGOUT: '/logout',
  // USERS URLS
  USERS: '/users',
  // INKASATORS URLS
  INKASATORS: '/inkasators',
  // CITIES URLS
  CITIES: '/cities',
  // ROLES URLS
  ROLES: '/roles',
  // FILIALS URLS
  FILIAL: '/filials',
  // DEPARTMENTS
  DEPARTMENTS: '/departments',
  // CURRENCY
  CURRENCY: '/currencies',
  // SESSIONS
  SESSIONS: '/sessions',
  // RATES
  RATES: '/rates',
  // OPERATIONS
  OPERATIONS: '/operations',
  // BALANCES
  BALANCE: '/balances',
  // ORDERS
  ORDERS: '/orders',
  // REPORTS
  REPORTS: '/reports',
  // EXPENSES
  EXPENSES: '/other_expenses',
  // ARRIVAL
  ARRIVAL: '/other_arrivals',
  // SALARY
  SALARY: '/salary',
  // VARIABLE
  VARIABLE: '/variables'
};
